import { render, staticRenderFns } from "./editartikel.vue?vue&type=template&id=5f5510b2&"
import script from "./editartikel.vue?vue&type=script&lang=js&"
export * from "./editartikel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports